module.exports = __webpack_public_path__ + "img/user-circle.16f6a916.svg";